export interface Language {
  code: string;
  name: string;
  countryCode: string;
}

export const languages: Language[] = [
  { code: 'pl', name: 'Polski', countryCode: 'PL' },
  { code: 'en', name: 'English', countryCode: 'GB' },
];

export const DEFAULT_LANGUAGE = languages[0];

export const availableLanguagesCodes = languages.map(language => language.code);